import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/images/logo-jsh.webp'


const _hoisted_1 = ["width"]

import { toRefs } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'image-item',
  props: {
  src: {
    type: String,
    required: true
  },
  width: {
    type: [String, Number],
    default: 70
  },
  height: {
    type: [String, Number],
    default: 70
  },
  radius: {
    type: [String, Number],
    default: 6
  }
},
  setup(__props) {

const props = __props
const { src, width, height, radius } = toRefs(props)

return (_ctx: any,_cache: any) => {
  const _component_a_image = _resolveComponent("a-image")!

  return (_openBlock(), _createBlock(_component_a_image, {
    width: _unref(width),
    height: _unref(height),
    preview: false,
    src: _unref(src),
    style: _normalizeStyle([{"overflow":"hidden"}, {
      borderRadius: _unref(radius) + 'px'
    }])
  }, {
    loader: _withCtx(() => [
      _createElementVNode("div", {
        class: "d-flex justify-content-center align-items-center",
        style: _normalizeStyle([{"background":"rgba(var(--gray-1))"}, {
          width: _unref(width) + 'px',
          height: _unref(height) + 'px',
        }])
      }, [
        _createElementVNode("img", {
          width: _unref(width) * (3/5),
          src: _imports_0,
          style: {"filter":"grayscale(100%)"}
        }, null, 8, _hoisted_1)
      ], 4)
    ]),
    _: 1
  }, 8, ["width", "height", "src", "style"]))
}
}

})